import dayjs from "dayjs";

import http from ":http";

import {
  SET_MESSAGES,
  SET_CURRENT_MESSAGE,
  CLEAR_CURRENT_MESSAGE,
  SET_FAVORED_MESSAGES
} from ":mutations";
import {
  REQUEST_MESSAGES,
  REQUEST_MESSAGE,
  REQUEST_FAVORED_MESSAGES,
  ADD_MESSAGE,
  UPDATE_MESSAGE,
  DELETE_MESSAGE
} from ":actions";

import M from "%const/messages";

const state = {
  messages: [],
  favoredMessages: [],
  pageable: {
    page: 1,
    size: 0,
    totalPages: 0
  },
  current: null,
  read: []
};

const mutations = {
  [SET_MESSAGES](state, { messages, pageable }) {
    state.messages = messages;
    state.pageable = pageable;
  },

  [SET_CURRENT_MESSAGE](state, { message }) {
    state.current = message;
    state.read.push(message.id);
  },

  [CLEAR_CURRENT_MESSAGE](state) {
    state.current = null;
  },

  [SET_FAVORED_MESSAGES](state, { messages }) {
    state.favoredMessages = messages;
  }
};

const actions = {
  [REQUEST_MESSAGES]({ commit }, { page, size, showDate = false }) {
    return http
      .get("/messages", {
        params: {
          date: showDate,
          page: page - 1,
          size,
          sort: "date,desc"
        }
      })
      .then(response =>
        commit(SET_MESSAGES, {
          messages: response.data.content,
          pageable: {
            page,
            size,
            totalPages: response.data.totalPages
          }
        })
      );
  },

  [REQUEST_MESSAGE]({ commit }, { id, showDate = false }) {
    return http
      .get(`/messages/${id}`, {
        params: {
          date: showDate
        }
      })
      .then(response =>
        commit(SET_CURRENT_MESSAGE, { message: response.data })
      );
  },

  [REQUEST_FAVORED_MESSAGES]({ commit }) {
    return http
      .get("/messages", {
        params: {
          page: 0,
          size: M.Favored.LIMIT,
          sort: "date,desc",
          favored: true,
          fields: "id,title"
        }
      })
      .then(response =>
        commit(SET_FAVORED_MESSAGES, { messages: response.data.content })
      );
  },

  [ADD_MESSAGE](_, { message }) {
    return http.post("/messages", message);
  },

  [UPDATE_MESSAGE](_, { id, message }) {
    return http.patch(`/messages/${id}`, message);
  },

  [DELETE_MESSAGE](_, { id }) {
    return http.delete(`/messages/${id}`);
  }
};

const getters = {
  messages: state =>
    state.messages.map(m => ({
      ...m,
      date: m.date && dayjs(m.date),
      read: state.read.includes(m.id)
    }))
};

export default {
  state,
  mutations,
  actions,
  getters
};
